module.exports = __webpack_public_path__ + "img/661.43908bc4.jpg";